module.exports = __webpack_public_path__ + "static/media/chevron-bottom.a24bdfad.svg";